import React, { useState, useEffect } from "react";
import {
  MantineProvider,
  Container,
  Paper,
  Title,
  Text,
  Group,
  Stack,
  Divider,
  LoadingOverlay,
  Alert,
  Avatar,
  Box,
} from "@mantine/core";
import { Footer } from "../../components/Footer/Footer";
import { djangoAxiosInstance } from "../../api";

const theme = {};

const ProfilePage = () => {
  const [profileData, setProfileData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    bar_jurisdiction: "",
    bar_registration_number: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem("access_token");
        const headers = {};
        if (accessToken) {
          headers["Authorization"] = `Bearer ${accessToken}`;
        }

        const response = await djangoAxiosInstance.get("/users/me", {
          headers,
        });
        setProfileData(response.data);
      } catch (err) {
        console.error("Error fetching profile data:", err);
        setError("Failed to load profile data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  return (
    <MantineProvider theme={theme}>
      <Container size="md" py="xl" pos="relative">
        <LoadingOverlay visible={loading} />

        <Title order={1} mb="xl">
          Profile
        </Title>

        {error ? (
          <Alert color="red" title="Error">
            {error}
          </Alert>
        ) : (
          profileData && (
            <Paper shadow="sm" p="xl" radius="md">
              <Box mb="xl">
                <Avatar size={120} radius={60} mx="auto" color="blue" mb="md">
                  {profileData.first_name && profileData.last_name
                    ? `${profileData.first_name.charAt(0)}${profileData.last_name.charAt(0)}`
                    : ""}
                </Avatar>
                <Title order={2}>
                  {profileData.first_name} {profileData.last_name}
                </Title>
                <Text color="dimmed" size="sm">
                  {profileData.email}
                </Text>
              </Box>

              <Divider mb="xl" />

              <Stack>
                <Title order={3} mb="md">
                  Personal Information
                </Title>

                <Group>
                  <Text size="md" color="dimmed">
                    Email Address
                  </Text>
                  <Text>{profileData.email}</Text>
                </Group>

                <Group>
                  <Text size="md" color="dimmed">
                    First Name
                  </Text>
                  <Text>{profileData.first_name}</Text>
                </Group>

                <Group>
                  <Text size="md" color="dimmed">
                    Last Name
                  </Text>
                  <Text>{profileData.last_name}</Text>
                </Group>

                {(profileData.bar_jurisdiction ||
                  profileData.bar_registration_number) && (
                  <>
                    <Divider my="md" />
                    <Title order={3} mb="md">
                      Professional Information
                    </Title>

                    {profileData.bar_jurisdiction && (
                      <Group>
                        <Text size="md" color="dimmed">
                          Bar Jurisdiction
                        </Text>
                        <Text>{profileData.bar_jurisdiction}</Text>
                      </Group>
                    )}

                    {profileData.bar_registration_number && (
                      <Group>
                        <Text size="md" color="dimmed">
                          Bar Registration Number
                        </Text>
                        <Text>{profileData.bar_registration_number}</Text>
                      </Group>
                    )}
                  </>
                )}
              </Stack>
            </Paper>
          )
        )}
      </Container>
      <Footer />
    </MantineProvider>
  );
};

export default ProfilePage;
